/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type ClinicalReportMaterialResultDtoTestResult =
  (typeof ClinicalReportMaterialResultDtoTestResult)[keyof typeof ClinicalReportMaterialResultDtoTestResult];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClinicalReportMaterialResultDtoTestResult = {
  PENDING: 'PENDING',
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
  NOT_EXECUTED: 'NOT_EXECUTED',
} as const;
